import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
// Namespaces for revamped surfaces, kept apart from the main files so each keeps en/es parity on its own
import accountSecurityEn from './locales/accountSecurity/en.json';
import accountSecurityEs from './locales/accountSecurity/es.json';
import personalSettingsEn from './locales/personalSettings/en.json';
import personalSettingsEs from './locales/personalSettings/es.json';

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    resources: {
      en: {translation: en, accountSecurity: accountSecurityEn, personalSettings: personalSettingsEn},
      es: {translation: es, accountSecurity: accountSecurityEs, personalSettings: personalSettingsEs},
    },

    interpolation: {
      escapeValue: false,
    },

    // detection: {
    //   order: ['navigator', 'localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
    // }
  });

export default i18n;
